import { motion } from "framer-motion";
import { QrCode, Star } from "lucide-react";

const REVIEW_URL = "https://www.google.com/maps/search/?api=1&query=Flatlander+Trucking+LLC+10010+Sterling+Rd+Rittman+OH+44270";

const REVIEWS = [
  {
    author: "Thomas Miller",
    when: "8 months ago",
    badge: "Repeat Customer",
    text: "I've used this company twice! And each time was a pleasant experience, he showed appreciation for my van and even my rust bucket of a truck, he was quick as he possibly could be and fair price!",
  },
  {
    author: "David Schultz",
    when: "4 months ago",
    badge: "Camper / RV Tow",
    text: "We had to move our large camper and we were in a real bind. Flatlander was professional and really made the process easy. Much appreciated!",
  },
];

export default function Reviews() {
  return (
    <section id="reviews" data-testid="reviews-section" className="bg-ink py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid grid-cols-1 gap-14 lg:grid-cols-12">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7 }}
            className="lg:col-span-4"
          >
            <p className="font-mono text-xs uppercase tracking-[0.3em] text-ember" data-testid="reviews-overline">
              Word From the Road
            </p>
            <div className="mt-6 flex items-end gap-3">
              <span className="font-display text-8xl font-black leading-none text-white sm:text-9xl" data-testid="reviews-rating-value">
                4.8
              </span>
              <span className="mb-2 font-mono text-sm text-slate-500">/ 5</span>
            </div>
            <div className="mt-4 flex gap-1" data-testid="reviews-stars">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className={`h-6 w-6 ${i < 5 ? "fill-hazard text-hazard" : "text-slate-600"}`} />
              ))}
            </div>
            <p className="mt-4 text-sm text-slate-400" data-testid="reviews-count">
              17 verified Google reviews
            </p>
          </motion.div>

          <div className="space-y-6 lg:col-span-8">
            {REVIEWS.map((r, i) => (
              <motion.blockquote
                key={r.author}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6, delay: i * 0.1 }}
                data-testid={`review-card-${r.author.toLowerCase().replace(/\s/g, "-")}`}
                className="border border-white/10 bg-surface p-8 transition-colors duration-300 hover:border-ember/40"
              >
                <div className="flex flex-wrap items-center justify-between gap-3">
                  <div className="flex gap-1">
                    {[...Array(5)].map((_, j) => (
                      <Star key={j} className="h-4 w-4 fill-hazard text-hazard" />
                    ))}
                  </div>
                  <span className="border border-ember/40 bg-ember/10 px-2.5 py-1 font-mono text-[10px] uppercase tracking-[0.2em] text-ember">
                    {r.badge}
                  </span>
                </div>
                <p className="mt-5 text-base leading-relaxed text-slate-200 sm:text-lg">"{r.text}"</p>
                <footer className="mt-6 font-mono text-xs uppercase tracking-[0.2em] text-slate-500">
                  {r.author} · {r.when}
                </footer>
              </motion.blockquote>
            ))}
          </div>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.7 }}
          data-testid="review-cta-panel"
          className="mt-14 grid grid-cols-1 items-center gap-8 border border-ember/40 bg-surface p-8 sm:grid-cols-12 sm:p-10"
        >
          <div className="sm:col-span-8">
            <p className="font-mono text-xs uppercase tracking-[0.3em] text-ember">Happy With the Save?</p>
            <h3 className="mt-3 font-display text-3xl font-extrabold uppercase leading-tight text-white sm:text-4xl">
              Leave Us a Google Review
            </h3>
            <p className="mt-3 max-w-lg text-sm text-slate-400">
              Thirty seconds of your time keeps trucks like ours rolling to the next person in a bind.
              Tap the button, or point your phone camera at the code.
            </p>
            <a
              href={REVIEW_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="leave-review-button"
              className="mt-6 inline-flex items-center gap-3 bg-ember px-8 py-4 font-display text-lg font-bold uppercase tracking-wider text-white transition-all duration-200 hover:bg-emberdark hover:shadow-[0_0_36px_rgba(139,92,246,0.35)]"
            >
              <Star className="h-5 w-5 fill-current" />
              Tap to Review on Google
            </a>
          </div>
          <div className="flex flex-col items-center gap-3 sm:col-span-4">
            <a href={REVIEW_URL} target="_blank" rel="noopener noreferrer" data-testid="review-qr-link" className="block border-4 border-white bg-white p-2 transition-transform duration-200 hover:scale-105">
              <img src="/images/google-review-qr.png" alt="QR code to leave Flatlander Trucking a Google review" className="h-36 w-36" data-testid="review-qr-image" />
            </a>
            <p className="flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.2em] text-slate-500">
              <QrCode className="h-3.5 w-3.5" /> Scan to review
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
